<one-card [notPadding]="true">

  <div class="fh-table-header">
    <span class="fh-table-title">Companies</span>
    <one-input
      class="fh-search"
      label="Search"
      type="search"
      autocomplete="off"
      (input)="onSearch($event)"
    ></one-input>
  </div>

  <div class="fh-divider"></div>

  <one-dynamic-table *ngIf="tableData" [tableData]="tableData"></one-dynamic-table>

</one-card>

<ng-template #actionsTemplate let-company="company">
  <div class="fh-row-actions">
    <button class="fh-row-actions__btn" title="View company">
      <span class="one-icon-eye"></span>
    </button>
  </div>
</ng-template>
